import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import InputPanel from "../../../../../../others/input-panel/index.js";
import PassengersContent from "../../../../components/content/index.js";
import usePassengersDesktop from "../../../../hooks/usePassengersDesktop.js";
import * as S from "./styled.js";
const DesktopPassengers = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { literals , children , columns , tooltipOptions  } = props;
    const { value , inputProps , disableIncrement , handleOnChange , handleOnSelectChange , renderFooter , basePanel  } = usePassengersDesktop(props);
    const panel = useMemo(()=>({
            ...basePanel,
            content: /*#__PURE__*/ _jsx(PassengersContent, {
                literals: literals,
                value: value,
                columns: columns,
                handleOnChange: handleOnChange,
                handleOnSelectChange: handleOnSelectChange,
                disableIncrement: disableIncrement,
                children: children
            }),
            footer: literals?.acceptLabel ? renderFooter : undefined
        }), [
        basePanel,
        children,
        columns,
        disableIncrement,
        handleOnChange,
        handleOnSelectChange,
        literals,
        renderFooter,
        value
    ]);
    const tooltipProps = useMemo(()=>({
            options: tooltipOptions
        }), [
        tooltipOptions
    ]);
    return /*#__PURE__*/ _jsx(S.PassengersWrapper, {
        "data-testid": "Passengers",
        className: props?.className,
        children: /*#__PURE__*/ _jsx(InputPanel, {
            ref: ref,
            inputProps: inputProps,
            panel: panel,
            tooltipProps: tooltipProps
        })
    });
});
DesktopPassengers.displayName = 'DesktopPassengers';
export default DesktopPassengers;

//# sourceMappingURL=index.js.map